var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCaption(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M486.4,51.2H25.6C11.5,51.2,0,62.7,0,76.8v358.4c0,14.1,11.5,25.6,25.6,25.6h460.8c14.1,0,25.6-11.5,25.6-25.6V76.8 C512,62.7,500.5,51.2,486.4,51.2z M477.9,426.7H34.1V85.3h443.7V426.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,349.9h0.3c21.9,0,42.1-7.6,58-20.3l-0.2,0.1l-21.1-26.8c-10,8-22.8,12.8-36.7,12.8h-0.3h0 c-33,0-59.7-26.7-59.7-59.7s26.7-59.7,59.7-59.7h0.3c13.9,0,26.7,4.8,36.8,12.9l-0.1-0.1l21.1-26.8c-15.7-12.6-35.8-20.1-57.8-20.1 h-0.4h0c-51.8,0-93.9,42-93.9,93.9S127.4,349.9,179.2,349.9L179.2,349.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.5,349.9h0.3c21.9,0,42.1-7.6,58-20.3l-0.2,0.1l-21.1-26.8c-10,8-22.8,12.8-36.7,12.8h-0.2h0 c-33,0-59.7-26.7-59.7-59.7s26.7-59.7,59.7-59.7h0.2c13.9,0,26.7,4.8,36.8,12.9l-0.1-0.1l21.1-26.8c-15.7-12.6-35.8-20.1-57.7-20.1 h-0.4h0c-51.8,0-93.9,42-93.9,93.9S301.7,349.9,353.5,349.9L353.5,349.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCaption);
export default __webpack_public_path__ + "static/media/icon-caption.4dee241a.svg";
export { ForwardRef as ReactComponent };